import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Box, Toolbar, IconButton, Badge, Tooltip, Button } from '@mui/material';
import type { AppBarProps } from '@mui/material';
import MenuIcon from '../../icons/Menu';
import AccountPopover from './utilityMenu/AccountPopover';
import ContentSearch from '../search/TopLevelSearch/ContentSearch';
import CustomerItem from './primaryMenu/CustomerItem';
import SalesItem from './primaryMenu/SalesItem';
import HelpItem from './primaryMenu/HelpItem';
import AdminItem from './primaryMenu/AdminItem';
import '../../theme/partials/GlobalNav.css';
import ReportItem from './primaryMenu/ReportItem';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AddIcon from '@mui/icons-material/Add';
import useNotifications from 'src/hooks/useNotifications';
import useCrm from 'src/hooks/useCrm';

interface GlobalHeaderNavbarProps extends AppBarProps {
  onSidebarMobileOpen?: () => void;
}

const GlobalHeaderNavbar: FC<React.PropsWithChildren<GlobalHeaderNavbarProps>> = (props) => {
  const { onSidebarMobileOpen, ...other } = props;
  const { bellTotal, openNotificationDrawer } = useNotifications();
  const { addActivityClicked } = useCrm();

  return (
    <AppBar {...other} className="global-nav">
      <Toolbar sx={{ minHeight: 64 }}>
        {/* Left Side */}
        <IconButton className="global-sidebar__toggle" onClick={onSidebarMobileOpen}>
          <MenuIcon fontSize="small" />
        </IconButton>

        <RouterLink to="/" className="sfa-header-logo">
          <img alt="logo" src="/static/sfa_logo_white.svg" width="60px" />
        </RouterLink>

        <Box className="global-header__menu">
          <Box className="global-header__menu__item">
            <CustomerItem isPopover />
          </Box>
          <Box className="global-header__menu__item">
            <SalesItem isPopover />
          </Box>
          <Box className="global-header__menu__item">
            <ReportItem isPopover />
          </Box>
          <Box className="global-header__menu__item">
            <HelpItem isPopover />
          </Box>
          <Box className="global-header__menu__item">
            <AdminItem isPopover />
          </Box>
        </Box>

        {/* Spacer */}
        <Box
          sx={{
            flexGrow: 1,
            ml: 2,
          }}
        />
        {/* Spacer */}
        {/* Right Side */}

        <Box>
          <Button variant="outlined" onClick={addActivityClicked} className="btn-white-outline">
            <AddIcon fontSize="small" /> Activity
          </Button>
        </Box>

        <Box sx={{ ml: 1 }}>
          <ContentSearch />
        </Box>

        <Box>
          <Tooltip title={`${bellTotal} tasks due`}>
            <IconButton size="large" onClick={() => openNotificationDrawer()}>
              <Badge badgeContent={bellTotal} color="error">
                <NotificationsIcon sx={{ color: '#fff' }} />
              </Badge>
            </IconButton>
          </Tooltip>
        </Box>

        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default GlobalHeaderNavbar;
